module.exports = __webpack_public_path__ + "assets/18c061920455053797ae94d3c208e211.svg";